import React from 'react';

import { TextField, Typography } from '@mui/material';

interface TextEditorBaseProps {
  title?: string;
  paragraph?: string;
  onPropChange: (key: string, value: any) => void;
}

const TitleParagraphEditor: React.FC<TextEditorBaseProps> = ({
  title,
  paragraph,
  onPropChange,
}) => {
  return (
    <>
      <Typography variant="h6">Content Options</Typography>
      <TextField
        label="Title (H4)"
        value={title || ''}
        onChange={(e) => onPropChange('title', e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Paragraph (Body 1)"
        value={paragraph || ''}
        onChange={(e) => onPropChange('paragraph', e.target.value)}
        fullWidth
        multiline
        margin="normal"
      />
    </>
  );
};

export default TitleParagraphEditor;
